import React from "react"
import PropTypes from "prop-types"
import MomentPropTypes from "react-moment-proptypes"
import EditCaseModal from "../EditCaseModal"
import { Button } from "reactstrap"
import "./PatientCaseSummary.scss"

const PatientCaseSummary = (props) => {
  const dateFormat = "M/D/YYYY • h:mma"
  const isArchived = props.archivedAt !== null

  let fakeId = 0
  const subjects = props.loading
    ? Array(3)
        .fill(0)
        .map(() => ({ entityId: ++fakeId }))
    : props.subjects

  return (
    <div className="PatientCaseSummary">
      <div className="patient-information">
        <div className="summary">
          <div>LOCATION</div>
          <div>OCCUPIED</div>
        </div>
        <div className="locations">
          {subjects.map((subject) => (
            <div
              key={subject.entityId}
              className={`location ${props.loading ? "loading" : ""}`}
            >
              <div className="top">
                <div className="name">{subject.entityName}</div>
                <div className="visits">({subject.visits} visits)</div>
              </div>
              <div className="time-range">
                <div>{subject.startAt?.format(dateFormat)}</div>
                <div>{subject.endAt?.format(dateFormat)}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="controls">
          <EditCaseModal
            id={props.id}
            internalId={props.caseId}
            subjects={props.subjects}
            caseType={"patientPositive"}
          />
        </div>
      </div>
      <div className="buttons">
        <Button
          color="primary"
          className="archive-button"
          onClick={() =>
            props.onArchive({
              id: props.id,
              archive: !isArchived,
              type: "patientPositive",
              facilityId: props.facilityId,
              subjects: props.subjects.map((subject) => ({
                entityId: subject.entityId,
                startAt: subject.startAt.format(),
                endAt: subject.endAt.format(),
              })),
            })
          }
        >
          {isArchived ? "Re-Open" : "Archive"}
        </Button>
      </div>
    </div>
  )
}

PatientCaseSummary.propTypes = {
  archivedAt: PropTypes.string,
  caseId: PropTypes.string,
  facilityId: PropTypes.string,
  loading: PropTypes.bool,
  onArchive: PropTypes.func,
  editComponent: PropTypes.elementType,
  subjects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      startAt: MomentPropTypes.momentObj,
      endAt: MomentPropTypes.momentObj,
      visits: PropTypes.number,
    })
  ),
  id: PropTypes.string,
}

PatientCaseSummary.defaultProps = {
  subjects: [],
}

export default PatientCaseSummary
